import { defineMessages } from "react-intl";

const messages = defineMessages({
    title: {
        id: "landing.app.title",
    },
    description: {
        id: "landing.app.student.description",
    },
});

export default messages;
